var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.625C6.48325 13.625 6.875 14.0167 6.875 14.5V20.5C6.875 20.9832 6.48325 21.375 6 21.375C5.51675 21.375 5.125 20.9832 5.125 20.5V14.5C5.125 14.0167 5.51675 13.625 6 13.625Z",
    fill: "#32D74B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.625C18.4832 9.625 18.875 10.0168 18.875 10.5V20.5C18.875 20.9832 18.4832 21.375 18 21.375C17.5168 21.375 17.125 20.9832 17.125 20.5V10.5C17.125 10.0168 17.5168 9.625 18 9.625Z",
    fill: "#32D74B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.625C12.4832 3.625 12.875 4.01675 12.875 4.5V20.5C12.875 20.9832 12.4832 21.375 12 21.375C11.5168 21.375 11.125 20.9832 11.125 20.5V4.5C11.125 4.01675 11.5168 3.625 12 3.625Z",
    fill: "#32D74B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaying);
export default __webpack_public_path__ + "static/media/playing.7a045b84250b76e6b8d64c01cd72e537.svg";
export { ForwardRef as ReactComponent };